import React, { useState } from 'react';
import { ChevronRight, ChevronDown } from 'lucide-react';
import './CollapsiblePanel.css';

interface CollapsiblePanelProps {
  title: string;
  defaultExpanded?: boolean;
  children: React.ReactNode;
}

export const CollapsiblePanel: React.FC<CollapsiblePanelProps> = ({ title, defaultExpanded = false, children }) => {
  const [expanded, setExpanded] = useState(defaultExpanded);

  return (
    <div className={`collapsible-panel ${expanded ? 'expanded' : ''}`}>
      <button 
        className="panel-header" 
        onClick={() => { setExpanded(!expanded); }}
        aria-expanded={expanded}
      >
        <span className="panel-icon">
          {expanded ? <ChevronDown size={18} /> : <ChevronRight size={18} className="chevron-icon rtl-flip" />}
        </span>
        <span className="panel-title">{title}</span>
      </button>
      {expanded && (
        <div className="panel-body">
          {children}
        </div>
      )}
    </div>
  );
};
